<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header  border-0">
        <h5 class="card-title font-bold py-3">گزارش کیف پول</h5>
      </div>
      <div class="card-body">
        <form @submit.prevent="submitHandler" class="row">
          <div class="col-5">
            <label>فیلتر تاریخ</label>
            <div class="row">
              <div class="col-6 d-flex">
                <span class="ml-2">از</span>
                <date-picker
                  type="date"
                  v-model="filter.date.startDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </div>
              <div class="col-6 d-flex">
                <span class="ml-2">تا</span>
                <date-picker
                  name="noname"
                  type="date"
                  v-model="filter.date.endDate"
                  format="YYYY-MM-DD"
                  display-format="jYYYY-jMM-jDD"
                />
              </div>
            </div>
          </div>

          <div class="col-6 mt-5">
            <button :disabled="disabled" type="submit" class="btn btn-primary">
              فیلتر
            </button>
            <button
              @click="removeFilter"
              :disabled="disabled"
              type="button"
              class="btn btn-warning mr-2"
            >
              برداشتن فیلتر
            </button>
          </div>
        </form>
        <div
        id="accountingWalletTable"
          class="row d-flex align-items-start justify-content-around"
          v-if="reports"
        >
          <table
            class="col-5 table table-striped table-bordered table-sm mt-5"
            :style="{ opacity: disabled ? '0.6' : 1 }"
          >
            <thead>
              <th>عنوان</th>
              <th>جمع کل</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in fields" :key="index" :class="item.statusColor">
                <td>{{ item.label }}</td>
                <td>{{ reports[item.key] | price }}</td>
              </tr>
            </tbody>
          </table>
          <table
            class="col-5 table table-striped table-bordered table-sm mt-5"
            :style="{ opacity: disabled ? '0.6' : 1 }"
          >
            <thead>
              <th>عنوان</th>
              <th>جمع کل</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in fields2" :key="index" :class="item.statusColor">
                <td>{{ item.label }}</td>
                <td>{{ reports[item.key] | price }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="reports == ''" class="alert alert-danger">
          موردی یافت تشد
        </div>
        <div v-else class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </div>
  </main>
</template>

<script>
import { BTable } from "bootstrap-vue";
class Filter {
  constructor() {
    this.date = {
      startDate: new Date().toISOString().split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
    };
  }
  set(filters) {
    Object.entries(filters).forEach(([index, value]) => {
      this[index] = value;
    });
  }
}
export default {
  name: "AccountingWallet",
  components: {
    BTable,
  },
  data() {
    return {
      disabled: true,
      reports: null,
      filter: new Filter(),
      appliedFilter: new Filter(),

      fields: [
        {
          key: "total_deposit",
          label: "مجموع تراکنش های ورودی",
          statusColor: 'success'
        },
        {
          key: "total_deposit_charge",
          label: "مجموع تراکنش های ورودی (شارژ کیف پول) ",
          statusColor: 'success'
        },
        {
          key: "total_deposit_not_charge",
          label: "مجموع تراکنش ها ی ورودی (به غیراز شارژ)",
          statusColor: 'success'
        },
        {
          key: "total_withdraw",
          label: "مجموع تراکنش های خروجی (برداشت)",
          statusColor: 'warning'
        },
        {
          key: "total_wallet",
          label: "مجموع موجودی کیف پول",
          statusColor: 'info'
        },
      ],
      fields2: [
        {
          key: "report_deposit",
          label: "مجموع افزایش کیف پول",
          statusColor: 'totalSuccess'
        },
        {
          key: "report_deposit_charge",
          label: "مجموع افزایش کیف پول (شارژ کیف پول)",
          statusColor: 'success'
        },
        {
          key: "report_deposit_not_charge",
          label: "مجموع افزایش کیف پول (به غیر از شارژ)",
          statusColor: 'success'
        },
        {
          key: "report_withdraw",
          label: "تراکنش های خروجی (برداشت) ",
          statusColor: 'warning'
        },
      ],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    removeFilter() {
      this.filter = new Filter();
      this.loadData();
    },
    submitHandler() {
      this.loadData();
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/accounting-report/wallet-transaction",
          {
            params: {
              start_date: this.appliedFilter.date.startDate,
              end_date: this.appliedFilter.date.endDate,
            },
          }
        );
        this.reports = response.data.data.result;
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
<style scoped>
#accountingWalletTable .success {
  background-color: #cbff7e;
  color: #000000;
}
#accountingWalletTable .totalSuccess {
  background-color: #9fd84a;
  color: #000000;
}
#accountingWalletTable .warning {
  background-color: #ffb2b2;
  color: #000000;
}
#accountingWalletTable .info {
  background-color: #688eff;
  color: #ffffff;
}
</style>
